const getSearchParams = () => {
  try {
    if (typeof window === 'undefined') return new URLSearchParams()
    return new URLSearchParams(window.location.search)
  } catch {
    return new URLSearchParams()
  }
}

const params = getSearchParams()
const buildConfig =
  typeof __FINDIFY_WEB_CONFIG__ === 'undefined' ? {} : __FINDIFY_WEB_CONFIG__

const readParam = (key) => {
  const value = params.get(key)
  return value === null || value === '' ? undefined : value
}

// Minimal subset used by this app. Extend as needed.
module.exports = {
  __esModule: true,
  default: {
    ...buildConfig,
    WORKSPACE_ID: readParam('workspace_id') ?? buildConfig.WORKSPACE_ID,
    QA_MODE: readParam('qa') ?? readParam('qa_mode') ?? buildConfig.QA_MODE,
  },
  ...buildConfig,
  WORKSPACE_ID: readParam('workspace_id') ?? buildConfig.WORKSPACE_ID,
  QA_MODE: readParam('qa') ?? readParam('qa_mode') ?? buildConfig.QA_MODE,
}
